export default __webpack_public_path__ + "static/scyhhx_hover-af42c05d745b902c878fb70bb3d46ed6.png";